import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import messages from '../messages';
import { WAREHOUSE_SETTINGS_URL } from '../constants';
import { useEditShipFromModalContext } from '../contexts/edit-ship-from-modal-context-provider';
import { useDeleteShipFromModalContext } from '../contexts/delete-ship-from-modal-context-provider';
import { useAreLocalDeliveryServicesAvailableForSeller } from '../../../../hooks/use-are-local-delivery-services-available-for-seller';
import { trackShipFromEditButtonClick } from '../../../../ship-from/tracking-events';
import { EventSourceStrings } from '../../../../tracking/tracking-constants';
import style from '../style.module.less';

const preventDefault = (e) => e?.preventDefault();

const ShipFromActionsButton = ({ shipFromId }) => {
  const { setEditShipFromId } = useEditShipFromModalContext();
  const { setDeleteShipFromId } = useDeleteShipFromModalContext();
  const sellerHasLocalDeliveryServices = useAreLocalDeliveryServicesAvailableForSeller();
  const onClickEdit = useCallback(() => {
    trackShipFromEditButtonClick(shipFromId, EventSourceStrings.SETTINGS_SHIP_FROM_LOCATIONS);
    setEditShipFromId(shipFromId);
  }, [shipFromId, setEditShipFromId]);
  return (
    <DropdownMenu className={style['action-menu-wrapper']} menuPosition='bottom-right'>
      <DropdownMenuToggler
        className={style['menu-toggle']}
        hideChevron
        onClick={preventDefault}
        openClassName={style['open-menu-toggle']}
        theme='link'
      >
        <div className={style['menu-toggle-contents']}>
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
      </DropdownMenuToggler>
      <DropdownMenuItem onClick={onClickEdit}>
        <FormattedMessage {...messages.editLocation} />
      </DropdownMenuItem>
      {sellerHasLocalDeliveryServices && (
        <DropdownMenuItem>
          <Link className={style['unstyled-link']} to={`${WAREHOUSE_SETTINGS_URL}/${shipFromId}/pickup-settings`}>
            <FormattedMessage {...messages.editPickupSettings} />
          </Link>
        </DropdownMenuItem>
      )}
      <DropdownMenuItem name={shipFromId} onClick={setDeleteShipFromId} theme='danger-link'>
        <div className={style.danger}>
          <FormattedMessage {...messages.deleteLocation} />
        </div>
      </DropdownMenuItem>
    </DropdownMenu>
  );
};

ShipFromActionsButton.propTypes = {
  shipFromId: PropTypes.string.isRequired,
};

export default ShipFromActionsButton;
